// extracted by mini-css-extract-plugin
module.exports = {"maxw300":"product-module--maxw300--7kCgR"};